import React, { useState, useEffect } from 'react';
//import { Container, Row, Col } from 'react-bootstrap';
import Lang from 'libraries/Lang';
import { getTopTrendsData } from 'libraries/trendsData';
import DestinationSectionLoader from './destinationSectionLoader';
import TopDestinationDetailSection from './topDestinationDetailSection';  

const TopDestinations = (prop) => {
    const [topDestinations, setTopDestinations] = useState(false);
    const [topItems, setTopItems] = useState([]);
    const [activeTitle, setActiveTitle] = useState({"sun" : "active", "europe" : "", "caus" : "", "others" : ""});
    const [isDataAvailable, setIsDataAvailable] = useState(false);
    const [isLoading, setIsLoading] = useState(true);
    const [firstDestName, setFirstDestName] = useState('');
    const [firstDestDesc, setFirstDestDesc] = useState('');
    const [showDescModal, setShowDescModal] = useState(false);

    useEffect(() => {
        const getTopDestinationsPromise = getTopTrendsData('/api/trends/topSearchedDestinations', prop.env, prop.start, prop.end);

        getTopDestinationsPromise.then((result) => {
            setIsLoading(false);
            if (result.isDataAvailable !== undefined && result.isDataAvailable == true) {
                setIsDataAvailable(true);
                setTopDestinations(result);
                setTopItems(result.countriesSun);
                showDescription(result.countriesSun);
            }
        });
    }, []);

    const showDescription = (data) => {
        if (data !== undefined && data !== null && data.length > 0) {
            setFirstDestName(data[0].name);
            setFirstDestDesc(data[0].description);
        } else {
            setFirstDestName('');
            setFirstDestDesc('');
        }
    }

    const showSun = () => {
        setActiveTitle({"sun" : "active", "europe" : "", "caus" : "", "others" : ""});
        setTopItems(topDestinations.countriesSun);
        showDescription(topDestinations.countriesSun);
    };

    const showEurope = () => {
        setActiveTitle({"sun" : "", "europe" : "active", "caus" : "", "others" : ""});
        setTopItems(topDestinations.countriesEurope);
        showDescription(topDestinations.countriesEurope);
    };

    const showCaUsCity = () => {
        setActiveTitle({"sun" : "", "europe" : "", "caus" : "active", "others" : ""});
        setTopItems(topDestinations.citiesCaUs);
        showDescription(topDestinations.citiesCaUs);
    };

    const showOthers = () => {
        setActiveTitle({"sun" : "", "europe" : "", "caus" : "", "others" : "active"});
        setTopItems(topDestinations.countriesOthers);
        showDescription(topDestinations.countriesOthers);
    };

    const updateCountryDetail = (data) => {
        if (data !== undefined && data !== null && data.name !== undefined && data.name !== null) {
            setFirstDestName(data.name);
        }
        if (data !== undefined && data !== null && data.description !== undefined && data.description !== null) {
            setFirstDestDesc(data.description);
        }
    };

    const showDetailModal = (value) => {
        setShowDescModal(value);
    };

    // https://www.redtag.ca/images/hotels/default.jpg
    const defaultImage = 'https://travel-img-assets.s3.us-west-2.amazonaws.com/no-image/no-image-500x300.png';

    return (
        <>
            { isLoading == false ?   
                <>
                    { isDataAvailable !== false ?
                        <div class="p-5 mx-sm-5">
                            <div className="container mb-4 pb-3">
                                <h3 className="font-weight-bold text-primary">{Lang.trans('trends_top_destinations.title')}</h3>
                                <p className="font-sm font-weight-600 text-black mb-0">{Lang.trans('trends_top_destinations.title_description')}</p>

                                <ul className="mt-3 text-left list-unstyled nav-tabs tabs-pill-bg d-inline-flex rounded-pill mb-3 overflow-x-auto" role="tablist">
                                    <li className="nav-item text-center">
                                        <a className={`p-2 nav-item d-block rounded-pill px-5 ${activeTitle.sun}`} id="sun" data-toggle="tab" role="tab" aria-controls="sun" aria-selected="true" onClick={showSun}>
                                            {Lang.trans('trends_top_destinations.sun')}
                                        </a>
                                    </li>
                                    <li className="nav-item text-center">
                                        <a className={`p-2 nav-item d-block rounded-pill px-5 ${activeTitle.europe}`} id="europe" data-toggle="tab" role="tab" aria-controls="europe" aria-selected="true" onClick={showEurope}>
                                            Europe
                                        </a>
                                    </li>
                                    <li className="nav-item text-center">
                                        <a className={`p-2 nav-item d-block rounded-pill px-5 ${activeTitle.caus}`} id="canada-us" data-toggle="tab" role="tab" aria-controls="canada-us" aria-selected="true" onClick={showCaUsCity}>
                                            Canada / US
                                        </a>
                                    </li>
                                    <li className="nav-item text-center">
                                        <a className={`p-2 nav-item d-block rounded-pill px-5 ${activeTitle.others}`} id="other" data-toggle="tab" role="tab" aria-controls="other" aria-selected="true" onClick={showOthers}>
                                            {Lang.trans('trends_top_destinations.others')}
                                        </a>
                                    </li>
                                </ul>

                                <div className="tab-content" id="whats-hot">

                                    {activeTitle.sun && activeTitle.sun == 'active' && (
                                        <TopDestinationDetailSection
                                            topDestinations={topDestinations}
                                            firstDestName={firstDestName}
                                            firstDestDesc={firstDestDesc}
                                            topItems={topItems}
                                            updateCountryDetail={updateCountryDetail}
                                            showDetailModal={showDetailModal}
                                            showDescModal={showDescModal}
                                        />
                                    )}

                                    {activeTitle.europe && activeTitle.europe == 'active' && (
                                        <TopDestinationDetailSection
                                            topDestinations={topDestinations}
                                            firstDestName={firstDestName}
                                            firstDestDesc={firstDestDesc}
                                            topItems={topItems}
                                            updateCountryDetail={updateCountryDetail}
                                            showDetailModal={showDetailModal}
                                            showDescModal={showDescModal}
                                        />
                                    )}

                                    {activeTitle.caus && activeTitle.caus == 'active' && (
                                        <TopDestinationDetailSection
                                            topDestinations={topDestinations}
                                            firstDestName={firstDestName}
                                            firstDestDesc={firstDestDesc}
                                            topItems={topItems}
                                            updateCountryDetail={updateCountryDetail}
                                            showDetailModal={showDetailModal}
                                            showDescModal={showDescModal}
                                        />
                                    )}

                                    {activeTitle.others && activeTitle.others == 'active' && (
                                        <TopDestinationDetailSection
                                            topDestinations={topDestinations}
                                            firstDestName={firstDestName}
                                            firstDestDesc={firstDestDesc}
                                            topItems={topItems}
                                            updateCountryDetail={updateCountryDetail}
                                            showDetailModal={showDetailModal}
                                        />
                                    )}

                                </div>
                            </div>
                        </div>
                    : null }
                </>
            : <DestinationSectionLoader />}
        </>
    );
};

export default TopDestinations;
